/** Builds the prompt a creator pastes into their coding agent. */
export function buildAgentPrompt(inviteUrl: string, prNumber?: string): string {
  if (prNumber) {
    return [
      `Build me a game using the Merels instructions already installed in this folder.`,
      `I have already connected this project to Merels PR #${prNumber}. Do not run merels connect again.`,
      `Run pnpm install, then run pnpm exec merels docs and follow the installed instructions stage by stage.`,
      `Stay on the saved PR preview target. Do not use the published Merels CLI or production Merels services.`,
      `Do not inspect or use any local checkout of the Merels platform, including any merels-wt directory.`,
      `Important: Do not attempt to build the game a different way.`,
      `I specifically want a game built using these instructions.`,
    ].join('\n')
  }

  return [
    `Build me a game following the instructions on this page: ${inviteUrl}`,
    `If you cannot access the page using the browser, fetch the content using curl -L or wget.`,
    `Run curl or wget outside the sandbox.`,
    `If you cannot do that either, tell me.`,
    `Important: Do not attempt to build the game a different way.`,
    `I specifically want a game built using these instructions.`,
  ].join('\n')
}

/** Builds the command the creator runs before launching an agent against a PR preview. */
export function buildPrBootstrapCommand(invitationToken: string, prNumber: string): string {
  return `npm exec --yes --package=https://pr-${prNumber}.merels.pages.dev/cli/merels-cli.tgz -- merels connect ${invitationToken} --pr ${prNumber}`
}
